export const ADMIN_CONTACT_SCHOOL = 'School';
export const ADMIN_CONTACT_PARTNER = 'Partner';
export const ADMIN_CONTACT_CITY = 'Stad';

export const ADMIN_CONTACT_TYPES = [
  { label: ADMIN_CONTACT_SCHOOL, value: ADMIN_CONTACT_SCHOOL },
  { label: ADMIN_CONTACT_PARTNER, value: ADMIN_CONTACT_PARTNER },
  { label: ADMIN_CONTACT_CITY, value: ADMIN_CONTACT_CITY }
];

export const ADMIN_CONTACT_CREATABLE_TYPES = [
  { label: ADMIN_CONTACT_SCHOOL, value: ADMIN_CONTACT_SCHOOL },
  { label: ADMIN_CONTACT_PARTNER, value: ADMIN_CONTACT_PARTNER }
];

export const ADMIN_CONTACT_PARTNER_ADMIN_ROLE = 'partner_admin';

export const ADMIN_CONTACT_SCHOOL_NET_ADMIN_ROLE = 'school_net_admin';
export const ADMIN_CONTACT_SCHOOL_ADMIN_ROLE = 'school_admin';

export const ADMIN_CONTACT_ROLES_OPTIONS = [
  { label: 'Dispatch', value: 'stad_dispatch' },
  { label: 'Admin', value: 'stad_admin' },
  { label: 'School Net Admin', value: ADMIN_CONTACT_SCHOOL_NET_ADMIN_ROLE },
  { label: 'School Net Begeleider', value: 'school_net_begeleider' },
  { label: 'School Admin', value: ADMIN_CONTACT_SCHOOL_ADMIN_ROLE },
  { label: 'School Medewerker', value: 'school_medewerker' },
  { label: 'Partner Admin', value: ADMIN_CONTACT_PARTNER_ADMIN_ROLE },
  { label: 'Partner Medewerker', value: 'partner_medewerker' },
  { label: 'Partner Niet Frequent', value: 'partner_niet_frequent' }
];

export const ADMIN_CONTACT_PARTNER_ROLES_OPTIONS = [
  { label: 'Partner Admin', value: ADMIN_CONTACT_PARTNER_ADMIN_ROLE },
  { label: 'Partner Medewerker', value: 'partner_medewerker' },
  { label: 'Partner Niet Frequent', value: 'partner_niet_frequent' }
];

export const ADMIN_CONTACT_NET_ROLES_OPTIONS = [
  { label: 'School Net Admin', value: ADMIN_CONTACT_SCHOOL_NET_ADMIN_ROLE },
  { label: 'School Net Begeleider', value: 'school_net_begeleider' }
];

export const ADMIN_CONTACT_SCHOOL_ALL_BRANCHES_ROLES_OPTIONS = [
  { label: 'School Admin', value: ADMIN_CONTACT_SCHOOL_ADMIN_ROLE },
  { label: 'School Medewerker', value: 'school_medewerker' }
];

export const ADMIN_CONTACT_SCHOOL_BRANCH_ROLES_OPTIONS = [{ label: 'School Medewerker', value: 'school_medewerker' }];

export const ADMIN_CONTACT_SCHOOL_ROLES_OPTIONS = [
  { label: 'School Net Admin', value: ADMIN_CONTACT_SCHOOL_NET_ADMIN_ROLE },
  { label: 'School Net Begeleider', value: 'school_net_begeleider' },
  { label: 'School Admin', value: ADMIN_CONTACT_SCHOOL_ADMIN_ROLE },
  { label: 'School Medewerker', value: 'school_medewerker' }
];

export const ADMIN_CONTACT_CITY_ROLES_OPTIONS = [
  { label: 'Dispatch', value: 'stad_dispatch' },
  { label: 'Admin', value: 'stad_admin' }
];
